import { Injectable, InjectionToken, inject } from '@angular/core';
import { SettingsState } from '@library/utils/interfaces/settings-state.interface';
import { Actions, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { GetUserSuccessAction, UserActions } from './user.action';
import * as UserSelectors from './user.selector';

export const USER_FACADE = new InjectionToken('USER_FACADE');
@Injectable()
export class UserFacade {
  protected store = inject<Store<SettingsState>>(Store);
  protected actions$ = inject(Actions);

  currentUser$ = this.store.pipe(select(UserSelectors.getUser));
  userMail$ = this.store.pipe(select(UserSelectors.getUserEmail));
  locale$ = this.store.pipe(select(UserSelectors.getLocale));
  keychain$ = this.store.pipe(select(UserSelectors.getKeychain));
  currentUserId$ = this.store.pipe(select(UserSelectors.getUserId));
  appTelemetry$ = this.store.pipe(select(UserSelectors.getUserAnalytics));

  /**
   * Loads data of the user
   * @returns Observable on action of type GetUserSuccess when it is fired
   */
  loadUser(): Observable<GetUserSuccessAction> {
    this.store.dispatch(UserActions.getUser());

    return this.actions$.pipe(ofType(UserActions.getUserSuccess), take(1));
  }
}
